import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedMethodsSection() {
  const failures = ['Las encuestas online son una pérdida de tiempo diseñada para pagarle poco a mucha gente.', 'Los negocios de dropshipping tardan meses en dar resultados y requieren conocimientos técnicos avanzados.', 'Los multiniveles se quedan con la mayor parte de tu ganancia y te obligan a reclutar personas.', 'La mayoría de las guías de reventa están en inglés y no entienden la realidad de la mujer latina en USA.'];
  return <section className="w-full bg-amber-50 py-16 md:py-24 text-slate-900" data-id="element-14">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-17">
            Por qué lo que has intentado antes no funcionó
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full" data-id="element-18"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-19">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-md border-l-4 border-red-500" data-id="element-20">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-21" />
              <p className="text-slate-700 font-medium" data-id="element-22">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}